import { View } from 'backbone.marionette';
import template from './index.jst';

export class MatchCentrePlayer extends View {
	get template() {
		return template;
	}

	get className() {
		return 'match-centre-row';
	}

	events() {
		return {
			'click': 'onPlayerShowPopup',
		}
	}

	initialize() {
		this.model.set({
			image_squads_path: process.env.SQUAD_LOGOS_PATH
		})
	}

	onPlayerShowPopup() {
		const
			id = parseInt(this.model.get('id'), 10),
			is_locked = this.model.get('is_locked');

		this.trigger('player:show:popup', { id, is_locked });
	}
}

export default MatchCentrePlayer;